import {
  IServiceListItem,
  TCalculationServicesAndDiscounts,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getReservationServices = (id: string): Promise<TCalculationServicesAndDiscounts> =>
  API.get(`/api/accommodation/calculations/${id}/services`).then(response => response?.data);
